/**
 * @author rmh
 * 功能：实体仓
 */

import { Service } from '@/tools'

export class FramePositionService<T extends TStock.framePosition> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.framePosition}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 模块说明：列表相关接口
   */
  pageList = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPage', data)
  }

  /**
   * 模块说明：启用-停用架位
   */
  updateStatus = <K extends T['ApiUpdateStatus']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiUpdateStatus', data)
  }

  /**
   * 模块说明：新增架位
   */
  framePositionAdd = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAdd', data, '操作成功')
  }
  /**
   * 模块说明：修改架位
   */
  framePositionUpdate = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiUpdate', data, '操作成功')
  }
  /**
   * 模块说明：查询指定柜组下的架位列表
   * /api/stock/whRack/v1/list
   */
  framePositionList = <K extends T['ApiList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiList', data)
  }
}
